import React from 'react'
import styled from 'styled-components'
import { useRouter } from 'next/router'
import { Link } from '@sentecacommerce-theme/lib'
import { LazyImage } from '../Common'
import { IconSearch } from '../Common/Icons/IconSearch'
import { ErrorPageProps } from './errorPage.props'

export const ErrorPage = ({
  title,
  subTitle,
  content,
  image,
  searchPlaceholder,
  suggestedLinks,
}: ErrorPageProps) => {
  const router = useRouter()

  const [query, setQuery] = React.useState('')

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()

    router.push(`/search?q=${query}`, undefined, { shallow: true })
  }
  return (
    <div className="container mt-5 pt-lg-5">
      <MainContent>
        <div
          className="d-lg-flex flex-column align-items-center"
          style={{ flexBasis: '80%' }}
        >
          <ImageContainer>
            <LazyImage width={100} height={100} src={image} />
          </ImageContainer>
          <TextContainer>
            {/* <Title>{title}</Title> */}
            <SubTitle>{subTitle}</SubTitle>
            <Content>{content}</Content>

            <Form onSubmit={handleSubmit}>
              <Input
                placeholder={searchPlaceholder}
                value={query}
                onChange={(e) => setQuery(e.target.value)}
              />
              <button>
                <IconSearch />
              </button>
            </Form>
          </TextContainer>
        </div>
        <Suggestions>
          <SuggestedTitle>{suggestedLinks.title}</SuggestedTitle>
          <SuggestedLinks>
            {suggestedLinks.links.map((link) => {
              return (
                <Link href={link.url} key={`Suggested-link-${link.name}`}>
                  <SuggestedLink>{link.name}</SuggestedLink>
                </Link>
              )
            })}
          </SuggestedLinks>
        </Suggestions>
      </MainContent>
    </div>
  )
}

const ImageContainer = styled.div.attrs({
  className: 'mx-auto mx-lg-4 mb-4 mb-lg-0',
})`
  width: 100%;
  max-width: 12rem;
`

const Title = styled.h1.attrs({
  'data-blogger': '',
})`
  font-size: 10rem;
  font-weight: bold;
`

const SubTitle = styled.h1.attrs({
  className: 'mb-4',
  'data-blogger': '',
})`
  max-width: 50rem;

  text-align: center;
  font-weight: bold;
  color: ${({ theme }) => theme.palette.greyTitle};
`

const Content = styled.div.attrs({
  className: 'mb-5',
})`
  max-width: 60rem;
  text-align: center;
`

const TextContainer = styled.div.attrs({
  className: 'mb-3 mt-lg-5 d-flex flex-column align-items-center',
})`
  color: ${({ theme }) => theme.palette.greyTitle};
`

const MainContent = styled.div.attrs({
  className: 'd-flex flex-column flex-lg-row justify-content-center',
})``

const Suggestions = styled.span.attrs({
  className:
    'mt-5 mt-lg-0 ml-lg-2 d-flex flex-column justify-content-center pl-4',
})`
  flex-basis: 20%;
  padding: 0rem;

  @media (min-width: ${({ theme }) => theme.breakpoints.lg.min}) {
    border-left: 1px solid ${({ theme }) => theme.palette.seaGreen};
    padding-left: 3rem;
  }
`

const SuggestedTitle = styled.h2`
  text-align: center;
  font-size: 2.2rem;
  color: ${({ theme }) => theme.palette.greyTitle};

  @media (min-width: ${({ theme }) => theme.breakpoints.lg.min}) {
    text-align: left;
  }
`
const SuggestedLinks = styled.ul.attrs({
  className: 'mt-4',
})`
  list-style: none;
  color: ${({ theme }) => theme.palette.greyTitle};
`

const SuggestedLink = styled.li.attrs({
  className: 'my-4 ',
})`
  font-size: 1.5rem;
  font-weight: bold;
  position: relative;
  width: max-content;

  &:hover {
    cursor: pointer;
    &:after {
      width: 90%;
      opacity: 1;
    }
  }
  &:before {
    content: '>';
    padding-right: 8px;
    color: ${({ theme }) => theme.palette.seaGreen};
  }
  &:after {
    content: '';
    position: absolute;
    left: 15px;
    bottom: -5px;
    width: 0px;
    height: 2px;
    margin: 5px 0 0 0;
    transition: all 0.2s ease-in-out;
    transition-duration: 0.3s;
    opacity: 0;
    background-color: ${({ theme }) => theme.palette.seaGreen};
  }
`

const Form = styled.form`
  width: 60rem;
  position: relative;

  @media (max-width: ${({ theme }) => theme.breakpoints.md.max}) {
    max-width: 30rem;
  }

  & button {
    min-width: 4rem;
    background: transparent;
    text-color: ${({ theme }) => theme.palette.seaGreen};
    max-width: 7rem;
    height: 100%;

    display: flex;
    align-items: center;

    position: absolute;
    right: -1rem;
    top: 0;

    padding: 0 !important;

    & svg {
      width: 2rem;
      height: auto;
      color: ${({ theme }) => theme.palette.seaGreen};
    }
  }
`
const Input = styled.input.attrs({
  className: 'px-4',
})`
  height: 4.8rem;
  border: 0.1rem solid ${({ theme }) => theme.palette.seaGreen};
  border-radius: 10rem;
  width: 100%;
  font-size: 1.6rem;
  text-overflow: ellipsis;
  color: ${({ theme }) => theme.palette.seaGreen};
  &::placeholder {
    color: ${({ theme }) => theme.palette.seaGreen};
  }
`
